import z from 'zod';

export const Schema = z.object({});
